import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  STORYTELLING_QUESTION_OTHER_KEY,
  getStorytellingPresetQuestionText,
  getStorytellingQuestionSelectOptions,
  resolveStorytellingQuestionKey,
} from "./storytellingQuestions";

function StorytellingQuestionField({ index, question, updateStorytellingField }) {
  const { t, i18n } = useTranslation();
  const options = getStorytellingQuestionSelectOptions(t);

  const [selectedKey, setSelectedKey] = useState(() =>
    resolveStorytellingQuestionKey(question, t, i18n)
  );

  useEffect(() => {
    setSelectedKey(resolveStorytellingQuestionKey(question, t, i18n));
  }, [index]);

  useEffect(() => {
    const resolved = resolveStorytellingQuestionKey(question, t, i18n);
    if (resolved) {
      setSelectedKey(resolved);
    }
  }, [question, t, i18n]);

  const isOther = selectedKey === STORYTELLING_QUESTION_OTHER_KEY;

  const handleSelectChange = (event) => {
    const key = event.target.value;
    setSelectedKey(key);

    if (!key) {
      updateStorytellingField(index, "question", "");
      return;
    }

    if (key === STORYTELLING_QUESTION_OTHER_KEY) {
      const wasCustom =
        resolveStorytellingQuestionKey(question, t, i18n) ===
        STORYTELLING_QUESTION_OTHER_KEY;
      if (!wasCustom) {
        updateStorytellingField(index, "question", "");
      }
      return;
    }

    updateStorytellingField(
      index,
      "question",
      getStorytellingPresetQuestionText(key, t)
    );
  };

  return (
    <div className="storytelling-entry-card__question-field">
      <label
        className="form-label text-primary"
        htmlFor={`storytelling-question-select-${index}`}
      >
        {t("storytellingQuestion")}
      </label>
      <select
        id={`storytelling-question-select-${index}`}
        className="form-select"
        value={selectedKey}
        onChange={handleSelectChange}
      >
        <option value="">{t("storytellingQuestionSelectPlaceholder")}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {isOther ? (
        <div className="storytelling-entry-card__question-other">
          <label
            className="form-label text-primary"
            htmlFor={`storytelling-question-other-${index}`}
          >
            {t("storytellingQuestionOtherLabel")}
          </label>
          <input
            id={`storytelling-question-other-${index}`}
            type="text"
            className="form-control"
            placeholder={t("storytellingQuestionPlaceholder")}
            value={question || ""}
            onChange={(e) =>
              updateStorytellingField(index, "question", e.target.value)
            }
            autoFocus
          />
        </div>
      ) : null}
    </div>
  );
}

export default StorytellingQuestionField;
